package com.schoolconnect.app.feature.parentnotes

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.animation.core.*
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppButton
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppSearchableDropdownField
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListActionIcons
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardsShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListTypography
import com.schoolconnect.app.designsystem.list.AdminRowActionItem
import com.schoolconnect.app.designsystem.list.AdminRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.mail
import ischoolconnect.sharedui.generated.resources.message
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.trash
import ischoolconnect.sharedui.generated.resources.user
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource

@Composable
fun ParentNotesScreen(
    state: ParentNotesUiState,
    onEvent: (ParentNotesUiEvent) -> Unit,
    onBack: () -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    var profileExpanded by remember { mutableStateOf(false) }
    var rowsMenuExpanded by remember { mutableStateOf(false) }
    var viewedRow by remember { mutableStateOf<ParentNoteRowUi?>(null) }
    var editingRow by remember { mutableStateOf<ParentNoteRowUi?>(null) }
    var editNote by remember { mutableStateOf<ParentNoteRowUi?>(null) }
    var deleteTarget by remember { mutableStateOf<ParentNoteRowUi?>(null) }
    var addDialogVisible by remember { mutableStateOf(false) }
    val window = pageWindow(state.pageIndex, state.pageSize, state.totalCount)
    val pageItems = state.rows

    LaunchedEffect(state.conversationCloseGeneration) {
        if (state.conversationCloseGeneration > 0 && editingRow != null) {
            editingRow = null
            onEvent(ParentNotesUiEvent.ViewDismissed)
        }
    }

    LaunchedEffect(editNote?.backendId, state.studentPickerOptions.size) {
        val note = editNote ?: return@LaunchedEffect
        val studentId = note.studentId.trim().ifBlank {
            state.studentPickerOptions.firstOrNull {
                it.name == note.studentName &&
                    it.className == note.className &&
                    it.sectionName == note.section
            }?.id.orEmpty()
        }
        if (studentId.isNotBlank()) onEvent(ParentNotesUiEvent.StudentSelected(studentId))
    }

    AdminListPageScaffold(
        title = "Parent Notes",
        subtitle = "Communicate with parents about students and track responses.",
        backgroundColor = AppBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        headerActions = {
            ShellTopRightActions(shellRoleLabel(shellRoleCode), shellRoleSubtitle(shellRoleCode), shellAvatarInitials(shellRoleLabel(shellRoleCode)), profileExpanded, { profileExpanded = it }, onChangeRole, onLogout)
        },
        summaryCards = { if (state.isStatisticsLoading) ParentNoteSummaryCardsShimmer() else {
            ParentNoteMetric("Total Notes", state.totalNotes.toString(), "Across all notes", Res.drawable.message, AppPrimary, AppPrimarySoft)
            ParentNoteMetric("Unread", state.unreadCount.toString(), "Parent has not read", Res.drawable.mail, Color(0xFFF36B21), Color(0xFFFFF0E9))
            ParentNoteMetric("Pending Parent", state.pendingParentCount.toString(), "Waiting for parent reply", Res.drawable.users, AppSuccess, AppSuccessSoft)
            ParentNoteMetric("Pending Teacher", state.pendingTeacherCount.toString(), "Waiting for your reply", Res.drawable.user, Color(0xFF5B20D9), Color(0xFFF1EBFF))
        } },
        toolbar = { ParentNotesFilterPanel(state, onEvent) },
        table = { modifier ->
            AdminListTableCard(
                modifier = modifier,
                minContentWidth = 1050.dp,
                header = { AdminListSortHeaderRow(listOf(
                    AdminListSortColumn("Parent Note ID", 1f, state.sortField == ParentNotesSortField.ID, state.sortAscending) { onEvent(ParentNotesUiEvent.SortChanged(ParentNotesSortField.ID)) },
                    AdminListSortColumn("Student Name", 1.2f, state.sortField == ParentNotesSortField.STUDENT, state.sortAscending) { onEvent(ParentNotesUiEvent.SortChanged(ParentNotesSortField.STUDENT)) },
                    AdminListSortColumn("Class", .65f, state.sortField == ParentNotesSortField.CLASS, state.sortAscending) { onEvent(ParentNotesUiEvent.SortChanged(ParentNotesSortField.CLASS)) },
                    AdminListSortColumn("Title", 1.55f, state.sortField == ParentNotesSortField.TITLE, state.sortAscending) { onEvent(ParentNotesUiEvent.SortChanged(ParentNotesSortField.TITLE)) },
                    AdminListSortColumn("Date", .85f, state.sortField == ParentNotesSortField.DATE, state.sortAscending) { onEvent(ParentNotesUiEvent.SortChanged(ParentNotesSortField.DATE)) },
                    AdminListSortColumn("Status", 1.1f, state.sortField == ParentNotesSortField.STATUS, state.sortAscending) { onEvent(ParentNotesUiEvent.SortChanged(ParentNotesSortField.STATUS)) }
                ), actionsLabel = "Actions", actionsWeight = .95f, actionsAlignment = Alignment.Center) },
                body = {
                    if (state.isLoading) AdminListTableShimmer(columns = listOf(AdminListHeaderColumn("Parent Note ID", 1f), AdminListHeaderColumn("Student Name", 1.2f), AdminListHeaderColumn("Class", .65f), AdminListHeaderColumn("Title", 1.55f), AdminListHeaderColumn("Date", .85f), AdminListHeaderColumn("Status", 1.1f), AdminListHeaderColumn("Actions", .95f)), rowCount = state.pageSize)
                    else if (pageItems.isEmpty()) Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) { Text("No parent notes found", color = AppNavy, fontWeight = FontWeight.Bold) }
                    else AdminListTableBody(items = pageItems, key = { it.backendId.ifBlank { it.parentNoteId } }, modifier = Modifier.fillMaxWidth().weight(1f)) { row ->
                        ParentNoteTableRow(row, onView = { viewedRow = null; editingRow = row; onEvent(ParentNotesUiEvent.ViewRequested(row.backendId)) }, onEdit = { editNote = row; onEvent(ParentNotesUiEvent.PickerOptionsRequested) }, onDelete = { deleteTarget = row })
                        if (row != pageItems.last()) HorizontalDivider(color = AppBorder)
                    }
                },
                footer = { AdminListFooter(pageText = pageFooterText(window, "notes"), pageIndex = window.pageIndex, pageCount = window.pageCount, onPageChanged = { onEvent(ParentNotesUiEvent.PageChanged(it)) }, pageSize = state.pageSize, rowsPerPageExpanded = rowsMenuExpanded, onRowsPerPageToggle = { rowsMenuExpanded = !rowsMenuExpanded }, onRowsPerPageDismiss = { rowsMenuExpanded = false }, onPageSizeChanged = { onEvent(ParentNotesUiEvent.PageSizeChanged(it)) }) }
            )
        },
        bottomAction = {
            Spacer(Modifier.weight(1f))
            AdminListPrimaryActionButton("Add Parent Note", painterResource(Res.drawable.plus), { addDialogVisible = true; onEvent(ParentNotesUiEvent.PickerOptionsRequested) }, Modifier.padding(top = 4.dp))
        }
    )

    ParentNoteViewDialog(
        row = null,
        detail = state.viewedNote,
        replies = state.viewedReplies,
        isLoading = state.isViewingNote,
        errorMessage = state.viewNoteError,
        onDismiss = { viewedRow = null; onEvent(ParentNotesUiEvent.ViewDismissed) }
    )
    AddParentNoteDialog(
        visible = addDialogVisible || editNote != null,
        initialNote = editNote,
        initialStudent = editNote?.let { note ->
            ParentNoteStudentPrefill(
                studentName = note.studentName,
                className = note.className,
                section = note.section,
                studentId = note.studentId
            )
        },
        onDismiss = { addDialogVisible = false; editNote = null },
        pickerState = state,
        onClassSectionSelected = { classSectionId -> onEvent(ParentNotesUiEvent.StudentPickerScopeChanged(classSectionId)) },
        onStudentPickerSearchChanged = { onEvent(ParentNotesUiEvent.StudentPickerSearchChanged(it)) },
        onStudentPickerLoadMore = { onEvent(ParentNotesUiEvent.StudentPickerLoadMore) },
        errorMessage = state.errorMessage,
        onStudentSelected = { onEvent(ParentNotesUiEvent.StudentSelected(it)) },
        onSave = { onEvent(ParentNotesUiEvent.CreateRequested(it)) },
        onUpdate = { onEvent(ParentNotesUiEvent.UpdateRequested(it)); editNote = null }
    )
    ParentConversationDialog(
        row = editingRow,
        detail = state.viewedNote,
        replies = state.viewedReplies,
        conversationInfo = state.viewedConversationInfo,
        allowReply = editingRow?.status?.equals("Closed", ignoreCase = true) != true,
        isLoading = state.isViewingNote,
        replyResetGeneration = state.replyResetGeneration,
        historyScrollGeneration = state.historyScrollGeneration,
        onDismiss = { editingRow = null; onEvent(ParentNotesUiEvent.ViewDismissed) },
        onSendReply = { message, attachmentFileIds -> editingRow?.backendId?.let { onEvent(ParentNotesUiEvent.ReplyRequested(it, message, attachmentFileIds)) } },
        onCloseConversation = { editingRow?.backendId?.let { onEvent(ParentNotesUiEvent.CloseRequested(it)) } }
    )
    deleteTarget?.let { target ->
        AppConfirmationDialog(
            onDismiss = { deleteTarget = null },
            title = "Delete Parent Note?",
            subtitle = "This note will be removed from the parent-notes records.",
            bodyText = "Delete ${target.title}?",
            confirmLabel = "Delete",
            tone = AppConfirmationDialogTone.Danger,
            onConfirm = { deleteTarget = null; onEvent(ParentNotesUiEvent.DeleteRequested(target.backendId)) }
        )
    }
}

@Composable
private fun RowScope.ParentNoteMetric(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, bg: Color) {
    AdminListSummaryCard(title, value, subtitle, painterResource(icon), accent, bg, AppMuted, modifier = Modifier.weight(1f))
}

@Composable
private fun ParentNotesFilterPanel(state: ParentNotesUiState, onEvent: (ParentNotesUiEvent) -> Unit) {
    AppCard(modifier = Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        BoxWithConstraints(Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 10.dp)) {
            val compact = maxWidth < 1180.dp
            val classSectionChoices = state.classSectionPickerOptions
                .distinctBy { it.id }
                .sortedWith(parentNoteClassSectionComparator())
            val selectedClassSection = classSectionChoices.firstOrNull { it.id == state.filters.classSectionId }?.label
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .then(if (compact) Modifier.horizontalScroll(rememberScrollState()) else Modifier),
                horizontalArrangement = Arrangement.spacedBy(14.dp),
                verticalAlignment = Alignment.Bottom
            ) {
                Column(modifier = if (compact) Modifier.width(260.dp) else Modifier.weight(1.3f), verticalArrangement = Arrangement.spacedBy(7.dp)) {
                    Text("Search by Title / Message", color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 13.sp)
                    BoxWithConstraints {
                        AdminListSearchField(state.searchQuery, { onEvent(ParentNotesUiEvent.SearchChanged(it)) }, "Search...", width = maxWidth, height = 44.dp, surfaceColor = Color.White, borderColor = AppBorder, textColor = AppNavy)
                    }
                }
                AppSearchableDropdownField(
                    label = "Class",
                    value = selectedClassSection.orEmpty(),
                    placeholder = "All",
                    options = classSectionChoices.map { it.label },
                    onValueChange = { value ->
                    val selected = classSectionChoices.firstOrNull { it.label == value }
                    onEvent(
                        ParentNotesUiEvent.FiltersChanged(
                            state.filters.copy(
                                classSectionId = selected?.id.orEmpty(),
                                student = "",
                                studentId = ""
                            )
                        )
                    )
                    },
                    modifier = if (compact) Modifier.width(220.dp) else Modifier.weight(1.35f),
                    valueFontWeight = FontWeight.Normal
                )
                AppSearchableDropdownField(
                    label = "Student",
                    value = state.filters.student,
                    placeholder = "All Students",
                    options = state.studentOptions,
                    onValueChange = { value ->
                        val studentId = state.studentPickerOptions.firstOrNull { it.displayLabel == value }?.id.orEmpty()
                        onEvent(ParentNotesUiEvent.FiltersChanged(state.filters.copy(student = value, studentId = studentId)))
                    },
                    modifier = if (compact) Modifier.width(180.dp) else Modifier.weight(1.1f),
                    valueFontWeight = FontWeight.Normal,
                    onSearchQueryChange = { onEvent(ParentNotesUiEvent.StudentPickerSearchChanged(it)) },
                    hasMore = state.studentPickerHasMore,
                    isLoadingMore = state.studentPickerLoadingMore,
                    onLoadMore = { onEvent(ParentNotesUiEvent.StudentPickerLoadMore) }
                )
                ParentNoteDropdown("Status", state.filters.status.ifBlank { "All" }, com.schoolconnect.app.repository.systemlookup.SystemLookupOptions.labels("PARENT_NOTE_STATUS"), if (compact) Modifier.width(135.dp) else Modifier.weight(1f)) { onEvent(ParentNotesUiEvent.FiltersChanged(state.filters.copy(status = it))) }
                AppOutlinedButton({ onEvent(ParentNotesUiEvent.FiltersReset) }, Modifier.width(116.dp).height(44.dp), contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 10.dp), colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary), shape = RoundedCornerShape(8.dp)) { Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(17.dp), tint = AppPrimary); Spacer(Modifier.width(6.dp)); Text("Clear", color = AppPrimary) }
            }
        }
    }
}

@Composable
private fun ParentNoteDropdown(label: String, value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit) =
    AppLabeledDropdownField(label, value, options, onSelected, modifier)

@Composable
private fun ParentNoteTableRow(row: ParentNoteRowUi, onView: () -> Unit, onEdit: () -> Unit, onDelete: () -> Unit) {
    Row(Modifier.fillMaxWidth().onViewDoubleClick(onView).heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
        AdminListTableBodyText(row.parentNoteId, Modifier.weight(1f), fontWeight = FontWeight.Medium)
        AdminListTableBodyText(row.studentName, Modifier.weight(1.2f))
        AdminListTableBodyText("${row.className}-${row.section}", Modifier.weight(.65f))
        AdminListTableBodyText(row.title, Modifier.weight(1.55f))
        AdminListTableBodyText(row.date, Modifier.weight(.85f))
        AdminListTableBodyText(row.status, Modifier.weight(1.1f), color = parentNoteStatusColor(row.status))
        Box(Modifier.weight(.95f), contentAlignment = Alignment.Center) {
            var expanded by remember { mutableStateOf(false) }
            AdminListActionIcons(onView = { expanded = false; onView() }, onEdit = { expanded = false; onEdit() }, editEnabled = !row.status.equals("Closed", ignoreCase = true), editDisabledDescription = "Edit unavailable for closed conversation") {
                androidx.compose.material3.IconButton(onClick = { expanded = true }, modifier = Modifier.size(32.dp)) { Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = AppNavy, modifier = Modifier.size(16.dp)) }
                AdminRowActionMenu(
                    sections = listOf(
                        listOf(AdminRowActionItem("Delete", { expanded = false; onDelete() }, painterResource(Res.drawable.trash), labelColor = Color(0xFFDC2626), iconTint = Color(0xFFDC2626)))
                    ),
                    onDismissRequest = { expanded = false },
                    expanded = expanded
                )
            }
        }
    }
}

@Composable
private fun RowScope.ParentNoteSummaryCardsShimmer() = AdminListSummaryCardsShimmer(
    cardCount = 4,
    cardHeight = 128.dp,
    cardShape = RoundedCornerShape(12.dp),
    contentPadding = PaddingValues(22.dp),
    iconSize = 70.dp,
    horizontalSpacing = 20.dp,
    titleWidth = 118.dp,
    titleHeight = 15.dp,
    valueWidth = 72.dp,
    valueHeight = 31.dp,
    subtitleWidth = 132.dp,
    subtitleHeight = 12.dp
)
